import urlParse from 'url-parse'

export const propsShallowDiff = (props, nextProps) =>
  Object.keys(nextProps).filter((key) => nextProps[key] !== props[key])

export const canonicalRedirect = (canonical, current, replace) => {
  // Decoding will turn `%20` in to ` ` but not a `+`, so we need to handle that
  // explicitly.
  if (
    decodeURI(canonical).replace(/\+/g, ' ') !==
    decodeURI(current).replace(/\+/g, ' ')
  ) {
    replace(canonical, 301)
    return true
  }

  return false
}

export const qs = (params) =>
  Object.entries(params)
    .map((pair) => pair.map(encodeURIComponent).join('='))
    .join('&')

export const abbreviate = (str = '', limit) =>
  str
    .split(/\s+/g)
    .map((word) => word[0])
    .join('')
    .slice(0, limit)
    .toUpperCase()

export const capitalCamelCase = (str, delim = '') =>
  str
    .split(/\s+/g)
    .map((word) => {
      if (word) {
        return `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`
      }
    })
    .join(delim)

export const changeHost = (uri, host) => {
  if (!host) {
    return uri
  }

  const {pathname, query, hash} = urlParse(uri)

  return `${host}${pathname}${query}${hash ? `#${hash}` : ''}`
}

export const idleify = (fn, timeout = 3000) => {
  if (!process.browser) {
    return fn
  }

  // Detect test environment and initialize immediately. Puppeteer attempts to
  // interact with the page right away so we need to have initialized and able
  // to handle user interaction.
  if (isTestEnv() || !window.requestIdleCallback) {
    return fn
  }

  return (...args) => requestIdleCallback(() => fn(...args), {timeout})
}

export const isTestEnv = () =>
  process.browser && window.location.hostname === 'local.ps.test'
